<template>
  <section :class="['bg-white border border-q4cl-border rounded-q4cl shadow-card', padded ? 'p-5 sm:p-6' : '', spaced ? 'mb-4' : '']">
    <header v-if="title || $slots.header" class="mb-3 flex items-start justify-between gap-2">
      <slot name="header">
        <h2 class="section-heading mb-0 border-b-0 pb-0">{{ $t(title) }}</h2>
      </slot>
      <slot name="header-actions" />
    </header>
    <slot />
  </section>
</template>

<script>
export default {
  name: 'Q4clCard',
  props: {
    title: { type: String, default: '' },
    padded: { type: Boolean, default: true },
    spaced: { type: Boolean, default: true }
  }
};
</script>
